"use strict";
function _typeof(obj) {
  return (_typeof =
    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
      ? function (obj) {
          return typeof obj;
        }
      : function (obj) {
          return obj &&
            "function" == typeof Symbol &&
            obj.constructor === Symbol &&
            obj !== Symbol.prototype
            ? "symbol"
            : typeof obj;
        })(obj);
}
function _toConsumableArray(arr) {
  return (
    _arrayWithoutHoles(arr) ||
    _iterableToArray(arr) ||
    _unsupportedIterableToArray(arr) ||
    _nonIterableSpread()
  );
}
function _nonIterableSpread() {
  throw new TypeError(
    "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
  );
}
function _unsupportedIterableToArray(o, minLen) {
  if (o) {
    if ("string" == typeof o) return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    return (
      "Object" === n && o.constructor && (n = o.constructor.name),
      "Map" === n || "Set" === n
        ? Array.from(o)
        : "Arguments" === n ||
          /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
        ? _arrayLikeToArray(o, minLen)
        : void 0
    );
  }
}
function _iterableToArray(iter) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(iter))
    return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  (null == len || len > arr.length) && (len = arr.length);
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    (descriptor.enumerable = descriptor.enumerable || !1),
      (descriptor.configurable = !0),
      "value" in descriptor && (descriptor.writable = !0),
      Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  return (
    protoProps && _defineProperties(Constructor.prototype, protoProps),
    staticProps && _defineProperties(Constructor, staticProps),
    Constructor
  );
}
function _inherits(subClass, superClass) {
  if ("function" != typeof superClass && null !== superClass)
    throw new TypeError("Super expression must either be null or a function");
  (subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: !0, configurable: !0 },
  })),
    superClass && _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function () {
    var result,
      Super = _getPrototypeOf(Derived);
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  return !call || ("object" !== _typeof(call) && "function" != typeof call)
    ? _assertThisInitialized(self)
    : call;
}
function _assertThisInitialized(self) {
  if (void 0 === self)
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called"
    );
  return self;
}
function _wrapNativeSuper(Class) {
  var _cache = "function" == typeof Map ? new Map() : void 0;
  return (_wrapNativeSuper = function (Class) {
    if (null === Class || !_isNativeFunction(Class)) return Class;
    if ("function" != typeof Class)
      throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== _cache) {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    return (
      (Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: !1,
          writable: !0,
          configurable: !0,
        },
      })),
      _setPrototypeOf(Wrapper, Class)
    );
  })(Class);
}
function _construct(Parent, args, Class) {
  return (_construct = _isNativeReflectConstruct()
    ? Reflect.construct
    : function (Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var instance = new (Function.bind.apply(Parent, a))();
        return Class && _setPrototypeOf(instance, Class.prototype), instance;
      }).apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return (
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {})),
      !0
    );
  } catch (e) {
    return !1;
  }
}
function _isNativeFunction(fn) {
  return -1 !== Function.toString.call(fn).indexOf("[native code]");
}
function _setPrototypeOf(o, p) {
  return (_setPrototypeOf =
    Object.setPrototypeOf ||
    function (o, p) {
      return (o.__proto__ = p), o;
    })(o, p);
}
function _getPrototypeOf(o) {
  return (_getPrototypeOf = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function (o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      })(o);
}
var FacetedFiltersForm = (function (_HTMLElement) {
  _inherits(FacetedFiltersForm, _wrapNativeSuper(HTMLElement));
  var _super = _createSuper(FacetedFiltersForm);
  function FacetedFiltersForm() {
    var _this;
    return (
      _classCallCheck(this, FacetedFiltersForm),
      ((_this = _super.call(this)).filterData = []),
      (_this.onActiveFilterClick = _this.onActiveFilterClick.bind(
        _assertThisInitialized(_this)
      )),
      (_this.debouncedOnSubmit = debounce(function (event) {
        _this.onSubmitHandler(event);
      }, 500)),
      _this
        .querySelector("form")
        .addEventListener(
          "input",
          _this.debouncedOnSubmit.bind(_assertThisInitialized(_this))
        ),
      window.addEventListener(
        "popstate",
        _this.onHistoryChange.bind(_assertThisInitialized(_this))
      ),
      _this.addClickOutsideHandler(document),
      _this
    );
  }
  return (
    _createClass(FacetedFiltersForm, [
      {
        key: "addClickOutsideHandler",
        value: function (container) {
          container
            .querySelectorAll(".facets__display")
            .forEach(function (item) {
              hideOnClickOutside(item);
            });
        },
      },
      {
        key: "onSubmitHandler",
        value: function (event) {
          event.preventDefault();
          var formData = new FormData(event.target.closest("form")),
            searchParams = new URLSearchParams(formData).toString();
          this.renderPage(searchParams, event);
        },
      },
      {
        key: "onActiveFilterClick",
        value: function (event) {
          event.preventDefault(),
            this.toggleActiveFacets(),
            this.renderPage(
              new URL(event.currentTarget.href).searchParams.toString()
            );
        },
      },
      {
        key: "onHistoryChange",
        value: function (event) {
          var _event$state,
            searchParams =
              (null === (_event$state = event.state) || void 0 === _event$state
                ? void 0
                : _event$state.searchParams) || "";
          this.renderPage(searchParams, null, !1);
        },
      },
      {
        key: "toggleActiveFacets",
        value: function () {
          var disable =
            !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
          document
            .querySelectorAll(".js-facet-remove")
            .forEach(function (element) {
              element.classList.toggle("disabled", disable);
            });
        },
      },
      {
        key: "renderPage",
        value: function (searchParams, event) {
          var updateURLHash =
              !(arguments.length > 2 && void 0 !== arguments[2]) ||
              arguments[2],
            _this$dataset = this.dataset,
            resultsContainer = _this$dataset.resultsContainer,
            sectionId = _this$dataset.sectionId,
            resultsGrid = _this$dataset.resultsGrid;
          if(document
            .querySelector(resultsContainer)
            .querySelector(resultsGrid)){
          document
            .querySelector(resultsContainer)
            .querySelector(resultsGrid)
            .classList.add("loading")}
          var url = ""
              .concat(window.location.pathname, "?section_id=")
              .concat(sectionId, "&")
              .concat(searchParams),
            filterDataUrl = function (element) {
              return element.url === url;
            };
          this.filterData.some(filterDataUrl)
            ? this.renderSectionFromCache(filterDataUrl, event)
            : this.renderSectionFromFetch(url, event),
            updateURLHash && this.updateURLHash(searchParams);
        },
      },
      {
        key: "renderSectionFromFetch",
        value: function (url, event) {
          var _this2 = this;
          fetch(url)
            .then(function (response) {
              return response.text();
            })
            .then(function (responseText) {
              var html = responseText;
              (_this2.filterData = [].concat(
                _toConsumableArray(_this2.filterData),
                [{ html: html, url: url }]
              )),
                _this2.renderFilters(html, event),
                _this2.renderProductGrid(html),
                _this2.renderProductCount(html);
            });
        },
      },
      {
        key: "renderSectionFromCache",
        value: function (filterDataUrl, event) {
          var html = this.filterData.find(filterDataUrl).html;
          this.renderFilters(html, event),
            this.renderProductGrid(html),
            this.renderProductCount(html);
        },
      },
      {
        key: "renderProductGrid",
        value: function (html) {
          var results = this.dataset.resultsContainer;
          document.querySelector(results).innerHTML = new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(results).innerHTML;
        },
      },
      {
        key: "renderProductCount",
        value: function (html) {
          var count = new DOMParser()
              .parseFromString(html, "text/html")
              .getElementById("ResultsProductCount").innerHTML,
            containerDesktop = document.getElementById(
              "ResultsProductCountDesktop"
            );
          (document.getElementById("ResultsProductCount").innerHTML = count),
            containerDesktop && (containerDesktop.innerHTML = count);
        },
      },
      {
        key: "renderFilters",
        value: function (html, event) {
          var parsedHTML = new DOMParser().parseFromString(html, "text/html"),
            facetDetailsElements = parsedHTML.querySelectorAll(
              "#FacetedFiltersForm .js-filter, #FacetedFiltersFormMobile .js-filter"
            ),
            matchesIndex = function (element) {
              var _event$target$closest;
              return (
                element.dataset.index ===
                (null == event ||
                null ===
                  (_event$target$closest =
                    event.target.closest(".js-filter")) ||
                void 0 === _event$target$closest
                  ? void 0
                  : _event$target$closest.dataset.index)
              );
            },
            facetsToRender = Array.from(facetDetailsElements).filter(function (
              element
            ) {
              return !matchesIndex(element);
            }),
            countsToRender =
              Array.from(facetDetailsElements).find(matchesIndex);
          document.querySelectorAll("#FacetedFiltersFormMobile .js-filter"),
            parsedHTML.querySelectorAll("#FacetedFiltersFormMobile .js-filter");
          this.shouldRedendersAllDisclosures(parsedHTML)
            ? this.renderDisclosures(parsedHTML)
            : (Array.from(facetDetailsElements)
                .filter(function (element) {
                  return matchesIndex(element);
                })
                .forEach(function (element) {
                  var target = document.querySelector(
                    '.js-filter[data-index="'.concat(
                      element.dataset.index,
                      '"]'
                    )
                  );
                  target.setAttribute("class", element.getAttribute("class")),
                    target.dataset.index.includes("mobile") &&
                      ((target.open = !0),
                      setTimeout(function () {
                        target.classList.add("menu-opening");
                      }));
                }),
              facetsToRender.forEach(function (element) {
                var target = document.querySelector(
                  '.js-filter[data-index="'.concat(element.dataset.index, '"]')
                );
                target &&
                  ((target.innerHTML = element.innerHTML),
                  target.setAttribute("class", element.getAttribute("class")));
              }));
          this.addClickOutsideHandler(document),
            this.renderActiveFacets(parsedHTML),
            this.renderAdditionalElements(parsedHTML),
            countsToRender &&
              this.renderCounts(
                countsToRender,
                event.target.closest(".js-filter")
              );
        },
      },
      {
        key: "shouldRedendersAllDisclosures",
        value: function (parsedHTML) {
          var current = [],
            brandnew = [],
            currentDisclosures = document.querySelectorAll(
              "#FacetedFiltersFormMobile .js-filter"
            ),
            newDisclosures = parsedHTML.querySelectorAll(
              "#FacetedFiltersFormMobile .js-filter"
            );
          return (
            currentDisclosures.forEach(function (item) {
              return current.push(item.dataset.name);
            }),
            newDisclosures.forEach(function (item) {
              return brandnew.push(item.dataset.name);
            }),
            current.join("-").length != brandnew.join("-").length
          );
        },
      },
      {
        key: "renderDisclosures",
        value: function (parsedHTML) {
          document.querySelector(
            "#FacetedFiltersForm .facets__wrapper"
          ).innerHTML = parsedHTML.querySelector(
            "#FacetedFiltersForm .facets__wrapper"
          ).innerHTML;
          document.querySelector(
            "#FacetedFiltersFormMobile .mobile-facets__main"
          ).innerHTML = parsedHTML.querySelector(
            "#FacetedFiltersFormMobile .mobile-facets__main"
          ).innerHTML;
        },
      },
      {
        key: "renderActiveFacets",
        value: function (html) {
          [".active-facets-mobile", ".active-facets-desktop"].forEach(function (
            selector
          ) {
            var activeFacetsElement = html.querySelector(selector);
            activeFacetsElement &&
              (document.querySelector(selector).innerHTML =
                activeFacetsElement.innerHTML);
          }),
            this.toggleActiveFacets(!1);
        },
      },
      {
        key: "renderAdditionalElements",
        value: function (html) {
          [".mobile-facets__open", ".mobile-facets__count", ".sorting"].forEach(
            function (selector) {
              html.querySelector(selector) &&
                (document.querySelector(selector).innerHTML =
                  html.querySelector(selector).innerHTML);
            }
          ),
            document
              .getElementById("FacetedFiltersFormMobile")
              .closest("menu-drawer")
              .bindEvents();
        },
      },
      {
        key: "renderCounts",
        value: function (source, target) {
          [".count-bubble", ".facets__selected"].forEach(function (selector) {
            var targetElement = target.querySelector(selector);
            source.querySelector(selector) &&
              targetElement &&
              (target.querySelector(selector).outerHTML =
                source.querySelector(selector).outerHTML);
          });
        },
      },
      {
        key: "updateURLHash",
        value: function (searchParams) {
          history.pushState(
            { searchParams: searchParams },
            "",
            ""
              .concat(window.location.pathname)
              .concat(searchParams && "?".concat(searchParams))
          );
        },
      },
      {
        key: "getSections",
        value: function () {
          return [
            {
              id: "main-collection-product-grid",
              section: document.querySelector(".main-collection-product-grid")
                .dataset.sectionId,
            },
          ];
        },
      },
    ]),
    FacetedFiltersForm
  );
})();

customElements.define("faceted-filters-form", FacetedFiltersForm);
var PriceRange = (function (_HTMLElement2) {
  _inherits(PriceRange, _wrapNativeSuper(HTMLElement));
  var _super2 = _createSuper(PriceRange);
  function PriceRange() {
    var _this3;
    return (
      _classCallCheck(this, PriceRange),
      (_this3 = _super2.call(this))
        .querySelectorAll("input")
        .forEach(function (element) {
          return element.addEventListener(
            "change",
            _this3.onRangeChange.bind(_assertThisInitialized(_this3))
          );
        }),
      _this3
        .querySelectorAll('input[type="range"]')
        .forEach(function (element) {
          return element.addEventListener("input", _this3.onSliderChange);
        }),
      _this3.setMinAndMaxValues(),
      _this3.initSlider(),
      _this3
    );
  }
  return (
    _createClass(
      PriceRange,
      [
        {
          key: "initSlider",
          value: function () {
            var slider = PriceRange.getSliderElements(this);
            if (slider.inputLeft) {
              var perecentage =
                  (100 * Number(slider.inputLeft.value)) /
                  Number(slider.inputLeft.getAttribute("max")),
                inversePercentage = 100 - perecentage,
                perecentageTwo =
                  (100 * Number(slider.inputRight.value)) /
                  Number(slider.inputRight.getAttribute("max")),
                inversePercentageTwo = 100 - perecentageTwo;
              (slider.inverseLeft.style.width = inversePercentage + "%"),
                (slider.inverseRight.style.width = inversePercentage + "%"),
                (slider.range.style.left = perecentage + "%"),
                (slider.range.style.right = inversePercentageTwo + "%"),
                (slider.thumbLeft.style.left = perecentage + "%"),
                (slider.thumbRight.style.left = perecentageTwo + "%");
            }
          },
        },
        {
          key: "onRangeChange",
          value: function (event) {
            event.currentTarget.classList.contains("handle")
              ? this.syncValuesFromSlider()
              : (this.adjustToValidValues(event.currentTarget),
                this.setMinAndMaxValues());
          },
        },
        {
          key: "onSliderChange",
          value: function (event) {
            var input = event.currentTarget,
              container = input.closest(".facets__price"),
              slider = PriceRange.getSliderElements(container);
            if ("left" === input.dataset.handle) {
              input.value = Math.min(input.value, slider.inputRight.value - 1);
              var value =
                (100 / (parseInt(input.max) - parseInt(input.min))) *
                  parseInt(input.value) -
                (100 / (parseInt(input.max) - parseInt(input.min))) *
                  parseInt(input.min);
              (slider.inverseLeft.style.width = value + "%"),
                (slider.range.style.left = value + "%"),
                (slider.thumbLeft.style.left = value + "%");
            }
            if ("right" === input.dataset.handle) {
              input.value = Math.max(input.value, slider.inputLeft.value - -1);
              var _value =
                (100 / (parseInt(input.max) - parseInt(input.min))) *
                  parseInt(input.value) -
                (100 / (parseInt(input.max) - parseInt(input.min))) *
                  parseInt(input.min);
              (slider.inverseRight.style.width = 100 - _value + "%"),
                (slider.range.style.right = 100 - _value + "%"),
                (slider.thumbRight.style.left = _value + "%");
            }
          },
        },
        {
          key: "setMinAndMaxValues",
          value: function () {
            var inputs = this.querySelectorAll('input:not([type="range"])'),
              minInput = inputs[0],
              maxInput = inputs[1];
            maxInput.value && minInput.setAttribute("max", maxInput.value),
              minInput.value && maxInput.setAttribute("min", minInput.value),
              "" === minInput.value && maxInput.setAttribute("min", 0),
              "" === maxInput.value &&
                minInput.setAttribute("max", maxInput.getAttribute("max"));
          },
        },
        {
          key: "adjustToValidValues",
          value: function (input) {
            var value = Number(input.value),
              min = Number(input.getAttribute("min")),
              max = Number(input.getAttribute("max"));
            value < min && (input.value = min),
              value > max && (input.value = max);
          },
        },
        {
          key: "syncValuesFromSlider",
          value: function () {
            var sliderInputs = this.querySelectorAll('input[type="range"]'),
              sliderMinInput = sliderInputs[0],
              sliderMaxInput = sliderInputs[1],
              inputs = this.querySelectorAll('input:not([type="range"])'),
              minInput = inputs[0],
              maxInput = inputs[1];
            minInput.value !== sliderMinInput.value &&
              ((minInput.value = Number(sliderMinInput.value)),
              minInput.dispatchEvent(
                new Event("input", { bubbles: !0, cancelable: !0 })
              )),
              maxInput.value !== sliderMaxInput.value &&
                ((maxInput.value = Number(sliderMaxInput.value)),
                maxInput.dispatchEvent(
                  new Event("input", { bubbles: !0, cancelable: !0 })
                ));
          },
        },
      ],
      [
        {
          key: "getSliderElements",
          value: function (container) {
            return {
              inverseLeft:
                null == container
                  ? void 0
                  : container.querySelector("div[inverse-left]"),
              inverseRight:
                null == container
                  ? void 0
                  : container.querySelector("div[inverse-right]"),
              range:
                null == container
                  ? void 0
                  : container.querySelector("div[range]"),
              thumbLeft:
                null == container
                  ? void 0
                  : container.querySelector("span[thumb-left]"),
              thumbRight:
                null == container
                  ? void 0
                  : container.querySelector("span[thumb-right]"),
              inputLeft: container.querySelector('input[data-handle="left"]'),
              inputRight: container.querySelector('input[data-handle="right"]'),
            };
          },
        },
      ]
    ),
    PriceRange
  );
})();
customElements.define("price-range", PriceRange);
var FacetRemove = (function (_HTMLElement3) {
  _inherits(FacetRemove, _wrapNativeSuper(HTMLElement));
  var _super3 = _createSuper(FacetRemove);
  function FacetRemove() {
    var _this4;
    return (
      _classCallCheck(this, FacetRemove),
      (_this4 = _super3.call(this))
        .querySelector("a")
        .addEventListener("click", function (event) {
          event.preventDefault(),
            (
              _this4.closest("faceted-filters-form") ||
              document.querySelector("faceted-filters-form")
            ).onActiveFilterClick(event);
        }),
      _this4
    );
  }
  return FacetRemove;
})();
customElements.define("facet-remove", FacetRemove);
var MenuDrawer = (function (_HTMLElement4) {
  _inherits(MenuDrawer, _wrapNativeSuper(HTMLElement));
  var _super4 = _createSuper(MenuDrawer);
  function MenuDrawer() {
    var _this5;
    _classCallCheck(this, MenuDrawer),
      ((_this5 = _super4.call(this)).mainDetailsToggle =
        _this5.querySelector("details"));
    var summaryElements = _this5.querySelectorAll("summary");
    return (
      _this5.addAccessibilityAttributes(summaryElements),
      "iPhone" === navigator.platform &&
        document.documentElement.style.setProperty(
          "--viewport-height",
          "".concat(window.innerHeight, "px")
        ),
      _this5.addEventListener(
        "keyup",
        _this5.onKeyUp.bind(_assertThisInitialized(_this5))
      ),
      _this5.addEventListener(
        "focusout",
        _this5.onFocusOut.bind(_assertThisInitialized(_this5))
      ),
      _this5.bindEvents(),
      _this5
    );
  }
  return (
    _createClass(MenuDrawer, [
      {
        key: "bindEvents",
        value: function () {
          var _this6 = this;
          this.querySelectorAll("summary").forEach(function (summary) {
            return summary.addEventListener(
              "click",
              _this6.onSummaryClick.bind(_this6)
            );
          }),
            this.querySelectorAll("button").forEach(function (button) {
              return button.addEventListener(
                "click",
                _this6.onCloseButtonClick.bind(_this6)
              );
            });
        },
      },
      {
        key: "addAccessibilityAttributes",
        value: function (summaryElements) {
          summaryElements.forEach(function (element) {
            element.setAttribute("role", "button"),
              element.setAttribute("aria-expanded", !1),
              element.setAttribute(
                "aria-controls",
                element.nextElementSibling.id
              );
          });
        },
      },
      {
        key: "onKeyUp",
        value: function (event) {
          if ("ESCAPE" === event.code.toUpperCase()) {
            var openDetailsElement = event.target.closest("details[open]");
            openDetailsElement &&
              (openDetailsElement === this.mainDetailsToggle
                ? this.closeMenuDrawer(
                    this.mainDetailsToggle.querySelector("summary")
                  )
                : this.closeSubmenu(openDetailsElement));
          }
        },
      },
      {
        key: "onSummaryClick",
        value: function (event) {
          var summaryElement = event.currentTarget,
            detailsElement = summaryElement.parentNode,
            isOpen = detailsElement.hasAttribute("open");
          detailsElement === this.mainDetailsToggle
            ? (isOpen && event.preventDefault(),
              isOpen
                ? this.closeMenuDrawer(summaryElement)
                : this.openMenuDrawer(summaryElement))
            : (trapFocus(
                summaryElement.nextElementSibling,
                detailsElement.querySelector("button")
              ),
              setTimeout(function () {
                detailsElement.classList.add("menu-opening");
              }));
        },
      },
      {
        key: "openMenuDrawer",
        value: function (summaryElement) {
          var _this7 = this;
          setTimeout(function () {
            _this7.mainDetailsToggle.classList.add("menu-opening");
          }),
            summaryElement.setAttribute("aria-expanded", !0),
            trapFocus(this.mainDetailsToggle, summaryElement),
            document.body.classList.add(
              "overflow-hidden-".concat(this.dataset.breakpoint)
            );
        },
      },
      {
        key: "closeMenuDrawer",
        value: function (event) {
          var elementToFocus =
            arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          void 0 !== event &&
            (this.mainDetailsToggle.classList.remove("menu-opening"),
            this.mainDetailsToggle
              .querySelectorAll("details")
              .forEach(function (details) {
                details.removeAttribute("open"),
                  details.classList.remove("menu-opening");
              }),
            this.mainDetailsToggle
              .querySelector("summary")
              .setAttribute("aria-expanded", !1),
            document.body.classList.remove(
              "overflow-hidden-".concat(this.dataset.breakpoint)
            ),
            removeTrapFocus(elementToFocus),
            this.closeAnimation(this.mainDetailsToggle));
        },
      },
      {
        key: "onFocusOut",
        value: function (event) {
          var _this8 = this;
          setTimeout(function () {
            _this8.mainDetailsToggle.hasAttribute("open") &&
              !_this8.mainDetailsToggle.contains(document.activeElement) &&
              _this8.closeMenuDrawer();
          });
        },
      },
      {
        key: "onCloseButtonClick",
        value: function (event) {
          var detailsElement = event.currentTarget.closest("details");
          this.closeSubmenu(detailsElement);
        },
      },
      {
        key: "closeSubmenu",
        value: function (detailsElement) {
          detailsElement.classList.remove("menu-opening"),
            removeTrapFocus(),
            this.closeAnimation(detailsElement);
        },
      },
      {
        key: "closeAnimation",
        value: function (detailsElement) {
          var animationStart;
          window.requestAnimationFrame(function handleAnimation(time) {
            void 0 === animationStart && (animationStart = time),
              time - animationStart < 400
                ? window.requestAnimationFrame(handleAnimation)
                : (detailsElement.removeAttribute("open"),
                  detailsElement.closest("details[open]") &&
                    trapFocus(
                      detailsElement.closest("details[open]"),
                      detailsElement.querySelector("summary")
                    ));
          });
        },
      },
    ]),
    MenuDrawer
  );
})();
customElements.define("menu-drawer", MenuDrawer);
